import { ImgVibeAtDevkrest1, ImgVibeAtDevkrest10, ImgVibeAtDevkrest11, ImgVibeAtDevkrest12, ImgVibeAtDevkrest13, ImgVibeAtDevkrest2, ImgVibeAtDevkrest3, ImgVibeAtDevkrest4, ImgVibeAtDevkrest5, ImgVibeAtDevkrest6, ImgVibeAtDevkrest7, ImgVibeAtDevkrest8, ImgVibeAtDevkrest9 } from "@/lib/images"
import { StaticImageData } from "next/image"

export const Text_Vibe_Devkrest = {
    heading: "Vibe at Devkrest",
    sub_heading: "From product launches to pizza parties, we believe great work deserves great moments. The vibe at Devkrest is a blend of focused energy and spontaneous fun—where deadlines are balanced with dance-offs, and collaboration often ends in celebration."
}

interface IMarqueeImgVibeAtDevkrest {
    image: StaticImageData
    image_alt: string
}

export const Marquee_Img_Vibe_At_Devkrest_Row_1: IMarqueeImgVibeAtDevkrest[] = [
    {
        image: ImgVibeAtDevkrest1,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest2,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest3,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest10,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest9,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest8,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest11,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest12,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest13,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
]

export const Marquee_Img_Vibe_At_Devkrest_Row_2: IMarqueeImgVibeAtDevkrest[] = [
    {
        image: ImgVibeAtDevkrest4,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest5,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest6,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest7,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest11,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest12,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
    {
        image: ImgVibeAtDevkrest13,
        image_alt: "Vibe At Dvekrest - Event Image",
    },
]